<div class="p-2 bg-panel page-height overflow-auto">
  <div class="page-container">
    <mat-card class="rounded-md" data-test="notifications-card">
      <mat-card-title>Notifications</mat-card-title>
      <mat-card-subtitle class="dashboard-subheading">
        Stay updated with important account information
      </mat-card-subtitle>

      <mat-card-content class="notifications-scrollable">
        @if (notifications$ | async; as notifications) {
          @for (notification of notifications; track notification) {
            <div
              class="notification-item"
              [ngClass]="notification.severity"
              data-test="notification-item"
            >
              <div class="notification-icon">
                <fa-icon [icon]="getIcon(notification.severity)" size="lg"></fa-icon>
              </div>

              <div class="notification-body">
                <div class="notification-header">
                  <span class="title" data-test="notification-title">
                    {{ notification.title }}

                    <span 
                      class="scope-badge"
                      [ngClass]="notification.scope"
                      data-test="notification-scope-badge">
                      {{ notification.scope === 'global' ? 'Global announcement' : 'Personal' }}
                    </span>
                  </span>
                  <span class="date" data-test="notification-date">{{ notification.sentTime | date: 'dd/MM/yyyy hh:mm a' }}</span>
                </div>

                <markdown class="detail" data-test="notification-detail" [data]="notification.detail"></markdown>
              </div>
            </div>
          }
        } @else {
          <div class="notification-empty" data-test="notification-empty-state">
            You have no notifications at this time.
          </div>
        }
      </mat-card-content>
    </mat-card>
  </div>
</div>